import React, { useState } from 'react';
import { AccountStatusTable } from './AccountStatusTable';

export const AccountStatus = ({ email }) => {

    // HARDCODED
    /* if(email=="TEIC@TEIC.COM"){
        email="cpaviglianiti@softtek.com"
    } */

    const [stateFilter, setStateFilter] = useState("");
    const [providerFilter, setProviderFilter] = useState("");
    const [invoiceFilter, setInvoiceFilter] = useState('');
    const [selectedCuit, setSelectedCuit] = useState(sessionStorage.getItem('selectedCuit') || null);

    return (
        <div style={{ width: 'auto' }}>
            <p style={{ color: "#009900", fontSize: "16px", textAlign: "right" }}>
            Se incluyen documentos recibidos por los canales definidos en las Políticas CUPA en los últimos 12 meses.
            </p>
            <AccountStatusTable
                email={email}
                stateFilter={stateFilter}
                setStateFilter={setStateFilter}
                providerFilter={providerFilter}
                setProviderFilter={setProviderFilter}
                invoiceFilter={invoiceFilter}
                setInvoiceFilter={setInvoiceFilter}
                selectedCuit={selectedCuit}
                setSelectedCuit={setSelectedCuit}
            />
            {/* <Grid container spacing={1} justifyContent="space-between" >
                <Grid item >
                    <AccountStatusBox text="Consultas" />
                </Grid>
                <Grid item >
                    <AccountStatusBox text="Gestión / Interferencias" />
                </Grid>
                <Grid item >
                    <AccountStatusBox text="Anuncios / Solicitudes" />
                </Grid>
            </Grid> */}
        </div>
    )
}
